export function getConvertedPrice(
  price: number,
  currency: string,
  currencyRates: any,
  numberOfDigits: 2,
): string;
export function getConvertedPrice(
  price: number,
  currency: string,
  currencyRates: any,
  numberOfDigits?: number,
): number;
export function getConvertedPrice(
  price: number,
  currency: string,
  currencyRates: any,
  numberOfDigits?: number,
) {
  //if (currency === 'USD') return parseFloat(Math.ceil(price).toFixed(numberOfDigits ?? 0));

  if (!currencyRates) return numberOfDigits === 2 ? price.toFixed(2) : price;

  const rate = currencyRates[currency];
  if (!rate) return numberOfDigits === 2 ? price.toFixed(2) : price;

  if (numberOfDigits == 2) {
    const truncated = Math.trunc(price * rate.rate_to_usd * 100) / 100;
    return truncated.toFixed(2);

  } else if (numberOfDigits) {
    return parseFloat((price * rate.rate_to_usd).toFixed(numberOfDigits ?? 0));
  } else {
    return parseFloat(Math.ceil(price * rate.rate_to_usd).toFixed(numberOfDigits ?? 0));
  }

}

export const getCurrencySymbol = (currency: string, currencyRates: any) => {
  if (!currencyRates) {
    return currencies.find((item) => item.code === currency)?.symbol || '$';
  }

  const rate = currencyRates[currency];
  return rate?.symbol || currencies.find((item) => item.code === currency)?.symbol || '$';
};

const currencyNameFormatter = typeof Intl !== 'undefined' && 'DisplayNames' in Intl
  ? new Intl.DisplayNames(['en'], { type: 'currency' })
  : null;

export const getCurrencyName = (currency: string) => {
  const normalizedCurrency = currency.toUpperCase();

  return currencies.find((item) => item.code === normalizedCurrency)?.name
    || currencyNameFormatter?.of(normalizedCurrency)
    || normalizedCurrency;
};

export const currencies = [
  { code: 'USD', symbol: '$', name: 'US Dollar' },
  { code: 'EUR', symbol: '€', name: 'Euro' },
  { code: 'GBP', symbol: '£', name: 'British Pound' },
  { code: 'CHF', symbol: 'CHF', name: 'Swiss Franc' },

];
